import React, { useContext, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form, Button } from "react-bootstrap";
import Footer from "./footer";
import Navbar from "./Navbar";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import { GlobalContext } from "../Context/GlobalState";
import swal from "sweetalert";
import { Helmet } from "react-helmet";
import { FaPhoneAlt, FaRegEnvelope, FaMapMarkerAlt, FaCheckCircle } from "react-icons/fa";
import "./HomeLayout.css";
import "./ResourcePages.css";
import "./CompanyPages.css";

const fields = [
  { name: "name", label: "Full name", type: "text", placeholder: "Your name", autoComplete: "name" },
  { name: "email", label: "Email address", type: "email", placeholder: "you@company.com", autoComplete: "email" },
  { name: "organizationName", label: "Organization name", type: "text", placeholder: "Company name", autoComplete: "organization" },
  { name: "mobile", label: "Mobile number", type: "tel", placeholder: "10-digit mobile number", autoComplete: "tel", inputMode: "numeric", maxLength: 10 },
  { name: "organizationType", label: "Organization type", type: "text", placeholder: "e.g. Private limited" },
  { name: "organizationAge", label: "Established year", type: "text", placeholder: "e.g. 2020", inputMode: "numeric" },
  { name: "organizationGST", label: "GST number", type: "text", placeholder: "Organization GST number" },
  { name: "telephone", label: "Telephone", type: "tel", placeholder: "Organization phone number" },
  { name: "teamSize", label: "Team size", type: "text", placeholder: "Number of employees", inputMode: "numeric" },
  { name: "address", label: "Organization address", type: "text", placeholder: "Your business address", autoComplete: "street-address", wide: true },
];
const Billpunchcontact = () => {

  const { setTransactionLoaderState } = useContext(GlobalContext);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    organizationName: "",
    organizationType: "",
    organizationAge: "",
    organizationGST: "",
    address: "",
    telephone: "",
    teamSize: "",
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    if (submitting) return;
    setSubmitting(true);
    setTransactionLoaderState(true);

    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        firm_name: formData.organizationName,
        firm_type: formData.organizationType,
        firm_age: formData.organizationAge,
        firm_gst: formData.organizationGST,
        firm_location: formData.address,
        firm_mobile: formData.telephone,
        firm_size: formData.teamSize,
      });
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/SuperadminContactus`,
        requestOptions
      );
      const data = await res.json();
      if (String(data.status) === "0") {
        swal("Success", data.result, "success");
      } else {
        swal("Error", data.result, "warning");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      swal("Unable to send", "Please try again, or call us on 9958854324.", "error");
    } finally {
      setTransactionLoaderState(false);
      setSubmitting(false);
    }
  };
  const validateForm = (e) => {
    e.preventDefault();
    let valid = true;
    const errors = {};
  
    if (!formData.name.trim()) {
      errors.name = "Name is required";
      valid = false;
    } else if (formData.name.trim() !== formData.name) {
      errors.name = "Name should not start with a space";
      valid = false;
    }
  
    if (!formData.email.trim()) {
      errors.email = "Email is required";
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Email address is invalid";
      valid = false;
    }
  
    if (!formData.mobile.trim()) {
      errors.mobile = "Mobile is required";
      valid = false;
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      errors.mobile = "Mobile number should be 10 digits";
      valid = false;
    }
  
    if (!formData.organizationName.trim()) {
      errors.organizationName = "Organization name is required";
      valid = false;
    } else if (formData.organizationName.trim() !== formData.organizationName) {
      errors.organizationName = "Organization name should not start with a space";
      valid = false;
    }
  
    if (!formData.organizationType.trim()) {
      errors.organizationType = "Organization type is required";
      valid = false;
    } else if (formData.organizationType.trim() !== formData.organizationType) {
      errors.organizationType = "Organization type should not start with a space";
      valid = false;
    }
  
    if (!formData.organizationAge.trim()) {
      errors.organizationAge = "Organization age is required";
      valid = false;
    } else if (formData.organizationAge.trim() !== formData.organizationAge) {
      errors.organizationAge = "Organization age should not start with a space";
      valid = false;
    }
  
    if (!formData.organizationGST.trim()) {
      errors.organizationGST = "Organization GST is required";
      valid = false;
    } else if (formData.organizationGST.trim() !== formData.organizationGST) {
      errors.organizationGST = "Organization GST should not start with a space";
      valid = false;
    }
  
    if (!formData.address.trim()) {
      errors.address = "Address is required";
      valid = false;
    } else if (formData.address.trim() !== formData.address) {
      errors.address = "Address should not start with a space";
      valid = false;
    }
  
    if (!formData.telephone.trim()) {
      errors.telephone = "Telephone is required";
      valid = false;
    } else if (formData.telephone.trim() !== formData.telephone) {
      errors.telephone = "Telephone should not start with a space";
      valid = false;
    }
  
    if (!formData.teamSize.trim()) {
      errors.teamSize = "Team size is required";
      valid = false;
    } else if (formData.teamSize.trim() !== formData.teamSize) {
      errors.teamSize = "Team size should not start with a space";
      valid = false;
    }
  
    setErrors(errors);
    if (Object.keys(errors).length === 0 && valid) {
      handleSubmit();
    }
  };
 
  useEffect(() => {
    const currentUrl = window.location.href; 
    const encodedUrl = encodeURIComponent(currentUrl);
  
    const script = document.createElement("script");
    script.src = `https://billpunch.com/SeoBix/seo_injection.php?webid=9d59d8c77c932613971c6c6c6af12ce8&url=${encodedUrl}&baseUrl=https%3A%2F%2Fbillpunch.com`;
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="billpunch-home resource-page company-page">
      <Helmet><title>Contact Us & Book a Demo | BillPunch</title><meta name="description" content="Talk to BillPunch about employee management, payroll and HR operations. Book a demo or contact our team in Noida." /></Helmet>
      <Navbar />
      <main>
        <header className="resource-hero"><div className="resource-container"><span className="resource-eyebrow">Let's Talk</span><h1>A better workday starts here.</h1><p>Book a demo, ask a question or tell us about your team. We'd love to help you find the right way forward with BillPunch.</p></div></header>
        <div className="resource-container contact-layout">
          <aside className="contact-info"><h2>Get in touch</h2><p>Connect with our team about your people, processes and business needs.</p><div className="contact-info__row"><span className="contact-info__icon contact-info__icon--green"><FaPhoneAlt aria-hidden="true" /></span><div><h3>Call us</h3><a href="tel:+919958854324">+91 9958854324</a></div></div><div className="contact-info__row"><span className="contact-info__icon contact-info__icon--purple"><FaRegEnvelope aria-hidden="true" /></span><div><h3>Email us</h3><a href="mailto:support@billpunch.com">support@billpunch.com</a></div></div><div className="contact-info__row"><span className="contact-info__icon"><FaMapMarkerAlt aria-hidden="true" /></span><div><h3>Visit our office</h3><address>ITHUM TOWER, B 218, Block A, Industrial Area, Sector 62, Noida, Uttar Pradesh 201309</address><a href="https://www.google.com/maps/search/?api=1&query=ITHUM+TOWER+Sector+62+Noida" target="_blank" rel="noopener noreferrer">Get Directions ↗</a></div></div><div className="contact-demo"><h3>What to expect from a demo</h3><ul>{["A walkthrough of BillPunch features","A conversation about your team's needs","Answers to your setup questions"].map(text => <li key={text}><FaCheckCircle aria-hidden="true" />{text}</li>)}</ul></div></aside>
          <section className="contact-form-card" aria-labelledby="contact-form-title"><h2 id="contact-form-title">Tell us about your business</h2><p>Share your details and our team will get in touch. All fields are required.</p><Form onSubmit={validateForm} noValidate><div className="contact-form-grid">{fields.map(({ name, label, wide, ...inputProps }) => <Form.Group key={name} controlId={`contact-${name}`} className={wide ? "contact-field--wide" : undefined}><Form.Label>{label} <span aria-hidden="true">*</span></Form.Label><Form.Control {...inputProps} name={name} value={formData[name]} onChange={handleChange} isInvalid={Boolean(errors[name])} required aria-describedby={errors[name] ? `contact-${name}-error` : undefined} /><Form.Control.Feedback type="invalid" id={`contact-${name}-error`}>{errors[name]}</Form.Control.Feedback></Form.Group>)}</div><div className="contact-form-submit"><Button type="submit" disabled={submitting}>{submitting ? "Sending…" : "Send Enquiry"} {!submitting && <span aria-hidden="true">→</span>}</Button><p>Prefer to talk? <a href="tel:+919958854324">Call 9958854324</a></p></div></Form></section>
        </div>
        <section className="resource-container contact-map" aria-labelledby="contact-map-title"><div><span className="resource-eyebrow">Find Us</span><h2 id="contact-map-title">Our office in Noida</h2><p>ITHUM TOWER, Sector 62, Noida, Uttar Pradesh</p></div><MapContainer /></section>
      </main>
      <Footer />
    </div>
  );
};
export default Billpunchcontact;

const MapContainer = () => (
  <iframe title="BillPunch office location at ITHUM Tower, Sector 62, Noida" src="https://maps.google.com/maps?q=ITHUM%20TOWER%20Sector%2062%20Noida&t=&z=15&ie=UTF8&iwloc=&output=embed" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
);
